import React, { useState } from 'react';
import { Typography, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { colors } from 'styles';
import { Link } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/basics';
import { breakpoint } from 'utils/mediaQueries';
import { FORM_TYPES } from 'components/pages/Index/FormModals/formConfigs';
import FormModal from 'components/pages/Index/FormModals/FormModal';

const StyledGrid = styled(Grid)`
  padding-top: 2rem;
  ${breakpoint.down('md')`
  padding-top: 4rem;`}
`;
const TextTeam = ({ data, lang }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <StyledGrid
      container
      justify="center"
      alignItems="center"
      direction={'column'}
      id="textTeam"
    >
      <Typography variant="body2"> {data.rawMarkdownBody}</Typography>
      <Button
        onClick={() => handleOpen()}
        size="large"
        variant={'contained'}
        customBackgroundColor={colors[data.frontmatter.color]}
        customHoverBackgroundColor={colors.shades[data.frontmatter.color].dark}
        color="primary"
        mt={1}
      >
        <FormattedMessage id="button.applyTeam" />
      </Button>
      <FormModal
        lang={lang}
        open={open}
        handleClose={handleClose}
        type={FORM_TYPES.CONTACT}
      />
    </StyledGrid>
  );
};

export default TextTeam;
